function ClassStudent() {
    return ( <div>ClassStudent</div> );
}

export default ClassStudent;